import { Link } from 'react-router-dom';

import DashboardPage from '../DashboardPage';
import styles from './ToolsLandingPage.module.css';

const tools = [
  {
    title: 'Entity Search',
    description: 'Search entities by type or ID.',
    href: '/tools/find',
  },
  {
    title: 'Deeplink Decoder',
    description: 'Decode LZString encoded deeplinks.',
    href: '/tools/lzstring-decoder',
  },
  {
    title: 'Snowflake query playground',
    description:
      'Run staged saved queries (admin) and inspect raw Snowflake rows.',
    href: '/tools/snowflake-query-playground',
  },
];

const ToolsLandingPage = () => {
  return (
    <DashboardPage title="Tools">
      <div className={styles.toolsGrid}>
        {tools.map((tool) => (
          <Link key={tool.href} to={tool.href} className={styles.toolCard}>
            <div className={styles.toolCardContent}>
              <h3 className={styles.toolCardTitle}>{tool.title}</h3>
              <p className={styles.toolCardDescription}>{tool.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </DashboardPage>
  );
};

export default ToolsLandingPage;
